import { createReducer, on } from '@ngrx/store';
import { UIActions } from './ui.actions';
import { UIState, initialState } from './ui.state';

export const reducer = createReducer(
  initialState,
  on(UIActions.get_language_list_start, (state: UIState) => ({
    ...state,
    error: null
  })),
  on(UIActions.get_language_list_success, (state: UIState, data) => {
    return {
      ...state,
      error: null,
      languageList: data.languageList
    };
  }),
  on(UIActions.get_language_list_fail, (state: UIState, error) => ({
    ...state,
    error,
    languageList: []
  }))
);
